module.exports = __webpack_public_path__ + "images/pro/img-pro-features-fed6f81d56d91c24af2f74e1fb2b2abe.png";